<template>
    <div class="collection">
        <CustomHeader title="酒店收藏" />
        <div class="p-2">
            <van-swipe-cell @open="switchSwipeCell(true)" @close="switchSwipeCell(false)" v-for="(item, index) in 20" :key="index">
                <hotel-item
                    @click="clickHotelItem('123')"
                    :cover="covers[generateCoverIndex(covers.length - 1)]"
                    title="金葵花酒店（深圳福田保税区福保地铁站店）"
                    type="经济型"
                    location="益田·皇岗口岸/福田口岸"
                />
                <template #right>
                    <van-button @click="cancelCollection(item)" block square type="danger" text="删除" />
                </template>
            </van-swipe-cell>
        </div>
    </div>
</template>
<script>
import { searchParamsKey } from "@/utils/variable";
export default {
    data() {
        return {
            covers: [
                "https://p1.meituan.net/320.0/hotelbiz/f584ba605de3de2734126682dca8b30c132376.jpg",
                "https://p0.meituan.net/216.0/tdchotel/6cb49aacf678a405073f34170bd3e5541999843.jpg.webp",
                "https://p0.meituan.net/320.0/tdchotel/77a149fabffd797afcace5670a2a53d0302457.jpg",
                "https://p0.meituan.net/320.0/tdchoteldark/755292baf62430553815da7a84c38809294988.jpg",
                "https://p0.meituan.net/320.0/tdchoteldark/832ba921c961a788f5abe14267ddf5b3410008.jpg",
            ],
            isOpen: false,
        };
    },
    methods: {
        cancelCollection(item){
            // .then(res=>{
            //     if(res.code===200){
            //         this.$toast.success("已删除")
            //     }
            // })
        },
        clickHotelItem(id) {
            if (!this.isOpen) {
                localStorage[searchParamsKey] = "";
                this.$router.push({ path: "/hotelDetail", query: { id } });
            }
        },
        switchSwipeCell(bol){
            setTimeout(()=>{
                this.isOpen = bol
            },100)
        },
        generateCoverIndex(size) {
            return Math.floor(Math.random() * Math.floor(size));
        },
    },
};
</script>

<style lang="scss" scoped>
.collection {
    /deep/.van-button--danger {
        width: 100%;
        height: 100%;
    }
}
</style>
